import api from './api';

export interface DataExchangeAsset {
  _id?: string;
  systemName: string;
  sourceSystems: string[];
  targetSystems: string[];
  exchangeType: string;
  piaReference?: string;
  usageSummary?: string;
  status: 'Active' | 'Inactive' | 'Deprecated' | 'In Development';
  dataClassification?: 'Public' | 'Internal' | 'Confidential' | 'Restricted';
  frequency?: 'Real-time' | 'Hourly' | 'Daily' | 'Weekly' | 'Monthly' | 'On-Demand';
  owner?: string;
  technicalContact?: string;
  businessContact?: string;
  lastUpdated?: Date;
  createdDate?: Date;
  notes?: string;
}

export interface DataExchangeStats {
  totalAssets: number;
  activeAssets: number;
  exchangeTypes: Array<{ _id: string; count: number }>;
  statusBreakdown: Array<{ _id: string; count: number }>;
}

class DataExchangeAssetsService {
  private baseURL = '/data-exchange-assets';

  async getAll(params?: {
    search?: string;
    status?: string;
    exchangeType?: string;
    sortBy?: string;
    order?: 'asc' | 'desc';
  }): Promise<DataExchangeAsset[]> {
    const response = await api.get(this.baseURL, { params });
    return response.data.data;
  }

  async getById(id: string): Promise<DataExchangeAsset> {
    const response = await api.get(`${this.baseURL}/${id}`);
    return response.data.data;
  }

  async create(asset: Partial<DataExchangeAsset>): Promise<DataExchangeAsset> {
    const response = await api.post(this.baseURL, asset);
    return response.data.data;
  }

  async update(id: string, asset: Partial<DataExchangeAsset>): Promise<DataExchangeAsset> {
    const response = await api.put(`${this.baseURL}/${id}`, asset);
    return response.data.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`${this.baseURL}/${id}`);
  }

  async getStats(): Promise<DataExchangeStats> {
    const response = await api.get(`${this.baseURL}/stats`);
    return response.data.data;
  }
}

export default new DataExchangeAssetsService();
